























































































import { Component, Prop, Vue } from 'vue-property-decorator';

import Quotes from '@/services/Quotes';
import * as Sentry from '@sentry/browser';

// Components
import Loading from '@/components/Global/Loading.vue';
import { quoteId, quoteExpiry, isQuoteExpired } from './QuoteFilters';
import TextField from '@/components/Form/TextField.vue';
import SelectField from '@/components/Form/SelectField.vue';

@Component({
	name: 'QuotesList',
	components: {
		Loading,
		TextField,
		SelectField,
	},
})
export default class QuotesList extends Vue {
	@Prop() private quotesList: any;
	private paginate: string[];
	private error: boolean;
	private loading: boolean;
	private className: string;
	private searchText: string;
	private filterSearchType: string;
	private updatedQuotesList: any[];
	private statusType: string;
	constructor() {
		super();
		this.updatedQuotesList = [];
		this.paginate = ['updatedQuotesList'];
		this.error = false;
		this.loading = true;
		this.searchText = '';
		this.filterSearchType = 'Email';
		this.statusType = '';
	}

	private async created() {
		try {
			// Get Users
			this.updatedQuotesList = this.quotesList;
		} catch (e) {
			Sentry.captureException(e);
			this.error = true;
		} finally {
			this.loading = false;
		}
	}

	private loadQuote(quote) {
		console.log('quote-list', quote);

		this.$router.push({
			name: 'BrokerQuoteDetails',
			params: {
				quote,
			},
		});
	}
	private search() {
		this.updatedQuotesList = this.quotesList;
		this.searchText = this.searchText.toLowerCase();

		if (this.filterSearchType === 'Email' && this.searchText) {
			const regex = new RegExp(this.searchText, 'g');
			const filteredQuotes = this.quotesList
				.map(quote => {
					if (quote.email !== undefined) {
						if (quote.email.match(regex)) {
							return quote;
						}
					}
				})
				.filter(quote => {
					if (quote !== undefined) {
						return quote;
					}
				});

			this.updatedQuotesList = filteredQuotes;
		} else if (this.filterSearchType === 'Status' && this.statusType) {
			// tslint:disable-next-line: prefer-const
			let filteredQuote = [];
			const status = this.statusType;
			this.quotesList.forEach(quote => {
				if (
					(isQuoteExpired(quote) !== 'expired' && status === 'Created') ||
					(isQuoteExpired(quote) === 'expired' && status === 'Expired')
				) {
					filteredQuote.push(quote);
				}
			});
			this.updatedQuotesList = filteredQuote;
		} else {
			this.updatedQuotesList = this.quotesList;
		}

		console.log('quotes', this.updatedQuotesList);
	}
	private changeSearchType($event) {
		this.filterSearchType = $event.target.value;
	}

	private changeStatusType($event) {
		this.statusType = $event.target.value;
	}

	private quoteId(quote) {
		return quoteId(quote);
	}

	private quoteExpiry(quote) {
		if (isQuoteExpired(quote) === 'expired') {
			return 'Expired';
		} else {
			return 'Quote Created';
		}
	}
}
